import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_06_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-06-01",
    "name": "腿屈伸固定远端",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "quadriceps",
    "tips": ["坐姿腿屈伸", "股四头孤立"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/26385b87c8c164232b8809db.mp4",
    "videoUrl": "/media/collections-20261008/videos/12a7d155ef8714bf75db1996.mp4",
    "targetMuscles": ["股四头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第6期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-06-02",
    "name": "腿屈伸屈髋",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "quadriceps",
    "tips": ["坐姿腿屈伸", "股四头孤立"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/011ded5c242f198aeedd4ea1.mp4",
    "videoUrl": "/media/collections-20261008/videos/2bebca93ce44e9d2b83f4866.mp4",
    "targetMuscles": ["股四头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第6期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-06-03",
    "name": "腿屈伸常规",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "quadriceps",
    "tips": ["坐姿腿屈伸", "股四头孤立"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-4ba331a0929503a06f12701c.mp4",
    "videoUrl": "/media/collections-20261008/videos/3bb2766d793a272229476235.mp4",
    "targetMuscles": ["股四头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第6期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
